import { EventName, useAnalytics } from '@/context/analytics-context';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function StripeRedirect({
  gatewayUrl,
  onBack = () => false,
}: {
  gatewayUrl: string;
  onBack: () => void;
}): JSX.Element {
  const { track } = useAnalytics();
  const { t } = useTranslation();

  useEffect(() => {
    // Track the redirect event
    track(EventName.InitiatedGateway, { type: 'CARD' });

    // Redirect to the gateway URL
    if (gatewayUrl) {
      window.location.href = gatewayUrl;
    }
  }, [gatewayUrl, track]);

  return (
    <div className="flex flex-col items-center">
      <div className="w-full max-w-[500px] rounded-lg bg-white p-8 text-center">
        <div className="mb-4">
          <div className="mx-auto h-8 w-8 animate-spin rounded-full border-b-2 border-blue-600" />
        </div>
        <p className="mb-4 text-gray-600">{t('redirectingToPayment')}</p>
        <button
          className="cursor-pointer text-center font-bold text-blue-600 hover:underline"
          onClick={onBack}
          type="button"
        >
          <span>{t('goBack')}</span>
        </button>
      </div>
    </div>
  );
}
